const PbxxRecord = require('../pbxx_record')

module.exports = class Invitation extends PbxxRecord {
  static get class_name() {
    return 'Invitation'
  }

  opt_out() {
    return this._mapper().opt_out(this.id).then((response) => {
      this.opted_out = response.data.opted_out
      return this
    }, (error) => {
      throw(error)
    })
  }

  opt_in() {
    return this._mapper().opt_in(this.id).then((response) => {
      this.opted_out = response.data.opted_out
      return this
    }, (error) => {
      throw(error)
    })
  }
}
